import React, { useState, useEffect } from 'react';
import { Modal, Button, Image } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { getObjectsById } from 'pages/AccessManagement/actions';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  visibleModal: {
    '& .modal-content': {
      width: '477px',
      height: '480px',
      margin: '0 auto',
    },
  },
  modalCloseBtn: {
    position: 'absolute',
    top: '15px',
    right: '13px',
  },
});

const ObjectViewModal = (props) => {
  const classes = useStyles();
  const { show, onHide } = props;

  const dispatch = useDispatch();

  // ✅ Safe Redux selector with fallback
  const objectsState = useSelector((state) => state.objectsState || {});
  const themeState = useSelector((state) => state.themeState || {});

  const [objectsData, setObjectsData] = useState({});

  useEffect(() => {
    if (objectsState.objectsRecord) {
      setObjectsData(objectsState.objectsRecord);
    }
  }, [objectsState.objectsRecord]);

  const showUpdateForm = (recordId) => {
    dispatch(getObjectsById(recordId, 'update'));
  };

  return (
    <Modal
      {...props}
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className={classes.visibleModal}
    >
      <Modal.Header className="d-block">
        <Modal.Title id="contained-modal-title-vcenter" className="text-center page-heading">
          Object
          <p className="text-secondary font-12 font-weight-normal">Access Management</p>
        </Modal.Title>
        <Button onClick={onHide} variant="none" className={`border-0 ${classes.modalCloseBtn}`}>
          <Image
            src={
              themeState.themeMode === 'dark'
                ? '/assets/images/close-circle-dark.svg'
                : '/assets/images/close-circle.svg'
            }
          />
        </Button>
      </Modal.Header>

      <Modal.Body className="border-bottom-0">
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium page-heading mb-0">Parent</p>
          <p className="font-13 font-weight-normal text-secondary mb-0">
            {!isEmpty(objectsData.parent_objects) ? objectsData.parent_objects.name : ''}
          </p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium page-heading mb-0">Name</p>
          <p className="font-13 font-weight-normal text-secondary mb-0">{objectsData.name}</p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium page-heading mb-0">Object Type</p>
          <p className="font-13 font-weight-normal text-secondary mb-0">
            {!isEmpty(objectsData.object_type) ? objectsData.object_type.opt_display : ''}
          </p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium page-heading mb-0">URL</p>
          <p className="font-13 font-weight-normal text-secondary mb-0">{objectsData.object_url}</p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium page-heading mb-0">Menu Order</p>
          <p className="font-13 font-weight-normal text-secondary mb-0">{objectsData.menu_order}</p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium page-heading mb-0">Menu Icon</p>
          <p className="font-13 font-weight-normal text-secondary mb-0">{objectsData.menu_icon}</p>
        </div>
        <div className="d-flex justify-content-between mb-3">
          <p className="font-13 font-weight-medium page-heading mb-0">Description</p>
          <p className="font-13 font-weight-normal text-secondary mb-0">{objectsData.description}</p>
        </div>
        <div className="d-flex justify-content-between mb-3 align-items-center">
          <p className="font-13 font-weight-medium page-heading mb-0">Status</p>
          <p className="font-13 font-weight-normal text-secondary mb-0">
            <span className="w-76 active-datatable">Active</span>
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer className="border-top-0 justify-content-center"></Modal.Footer>
    </Modal>
  );
};

export default ObjectViewModal;
